/**
 * Idle-schedules inventory ledger health scan + soft-freeze COGS when a business is active.
 * (ADR-0016 V1.9 boot recovery)
 */

import { useEffect } from 'react';
import { useBusinessMeta } from '../features/meta/hooks/useBusinessMeta.js';

export default function InventoryLedgerHealthScheduler() {
  const { currentBusinessId } = useBusinessMeta();

  useEffect(() => {
    if (!currentBusinessId) return undefined;
    let cancelled = false;
    (async () => {
      try {
        const { scheduleInventoryLedgerHealthScan } = await import(
          '../domain/inventory/detectors'
        );
        if (cancelled) return;
        await scheduleInventoryLedgerHealthScan({
          businessId: currentBusinessId,
          enableSafeMode: true,
          clearSafeModeWhenOk: false
        });
      } catch {
        /* best-effort */
      }

      try {
        const { scheduleSoftFreezeSalesBackfillOnBoot } = await import(
          '../domain/finance'
        );
        if (cancelled) return;
        // After health scan idle — freeze a bounded batch of legacy unfrozen sales
        await scheduleSoftFreezeSalesBackfillOnBoot({
          businessId: currentBusinessId,
          limit: 500
        });
      } catch {
        /* best-effort */
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [currentBusinessId]);

  return null;
}
